import { motion } from "framer-motion";
import { Search, Wrench, TrendingUp, Trophy } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Search,
    title: "Deep Culver City audit",
    desc: "We map every keyword your competitors rank for that you don't. We find the gaps. We hand you a roadmap in week one.",
  },
  {
    n: "02",
    icon: Wrench,
    title: "Fix the foundation (days 1-30)",
    desc: "Technical SEO, Google Business Profile optimization, schema, site speed, local citations. The boring stuff that actually moves the needle.",
  },
  {
    n: "03",
    icon: TrendingUp,
    title: "Build authority (days 30-60)",
    desc: "Hyper-local content, neighborhood pages, real backlinks from West Side publications. Google starts to trust you.",
  },
  {
    n: "04",
    icon: Trophy,
    title: "Dominate the map (days 60-90)",
    desc: "Page-one rankings for your money keywords. Top-3 in the local pack. Phone starts ringing. We scale what's working.",
  },
];

const ProcessSection = () => {
  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="page-container">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary/10 text-secondary text-xs font-semibold uppercase tracking-wider mb-4">
            The 90-day playbook
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground">
            How we get Culver City businesses to{" "}
            <span className="text-secondary">page one in 90 days.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative p-7 rounded-2xl bg-card border border-border hover:border-accent/50 hover:shadow-xl transition-all group"
            >
              <div className="font-heading text-6xl font-bold text-muted/60 group-hover:text-accent/30 transition-colors absolute top-4 right-5">
                {s.n}
              </div>
              <div className="relative">
                <div className="w-12 h-12 rounded-xl bg-secondary/10 flex items-center justify-center mb-5 group-hover:bg-secondary group-hover:text-primary-foreground transition-colors">
                  <s.icon className="w-6 h-6 text-secondary group-hover:text-primary-foreground transition-colors" />
                </div>
                <h3 className="font-heading text-xl font-bold text-foreground mb-3">
                  {s.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
